// Load Styles
import '../scss/main.scss';


// Load Bootstrap init
import {initBootstrap} from "./bootstrap.js";

// Loading bootstrap with optional features
initBootstrap({
  tooltip: true,
  popover: true,
  toasts: true,
  scrollspy: true,
  navbar: true,
	modal: true,
});

// Your app code
//console.log(`Hello ${process.env.HELLO}`);
